export default [
    {
        path: '',
        name: 'payoutStatements',
        component: () => import('../views/payoutStatements/index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
        children: [{
            path: '/(uk/|ru/)?/payout-statements',
            name: 'PayoutStatementsSettings',
            component: () => import('../views/payoutStatements/tabs/settings'),
            query: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-autopark',
                title: 'Настройки ведомостей'
            }
        }, {
            path: '',
            name: 'PayoutStatementsList',
            component: () => import('../views/payoutStatements/tabs/list'),
            query: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-autopark',
                title: 'Список ведомостей'
            },
            children: [{
                path: '/(uk/|ru/)?/payout-list',
                name: 'PayoutStatementsListActive',
                component: () => import('../views/payoutStatements/tabs/active'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-autopark',
                    title: 'Активные'
                },
            }, {
                path: '/(uk/|ru/)?/payout-list/archive',
                name: 'PayoutStatementsListArchive',
                component: () => import('../views/payoutStatements/tabs/archive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-autopark',
                    title: 'Архив'
                },
            }]
        }]
    }, {
        path: '/(uk/|ru/)?/sos',
        name: 'SosList',
        component: () => import('../views/sos/SosList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon: '#icon-warning',
            title: 'SOS'
        },
    }, {
        path: '/(uk/|ru/)?/sos/detail',
        name: 'SosDetail',
        component: () => import('../views/sos/SosDetail'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon: '#icon-warning',
            title: 'SOS Детали'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/create',
        name: 'payoutStatementsCreate',
        component: () => import('../views/payoutStatements/form/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/edit',
        name: 'payoutStatementsEdit',
        component: () => import('../views/payoutStatements/form/edit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-create',
        name: 'PayoutStatementsListCreate',
        component: () => import('../views/payoutStatements/form/listEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit',
        name: 'PayoutStatementsListEdit',
        component: () => import('../views/payoutStatements/form/listEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit/item-view',
        name: 'PayoutStatementsListItemView',
        component: () => import('../views/payoutStatements/form/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    }, {
        path: '/(uk/|ru/)?/payout-statements/list-edit/item-create',
        name: 'PayoutStatementsListItemCreate',
        component: () => import('../views/payoutStatements/form/view'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-autopark',
            title: 'Выплаты по ведомостям'
        },
    },
]
